import React from 'react';

function PagosAdmin(props) {
    return (
        <div className="card list-inline-item">
            <div className="card-body">
                <div className="card-title d-flex align-items-start justify-content-between">
                    <div className="card-title text-primary ">
                        <i className="bx bx-wallet bx-sm align-middle"></i> CARTERA
                    </div>
                    <div className="dropdown">
                        <button
                            className="btn"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i className="bx bx-dots-vertical-rounded"></i>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt3">
                            <span className="dropdown-item" >View More</span>
                            <span className="dropdown-item" >Delete</span>
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-start row-cols-2'>
                    <div className='list-inline-item'>
                        <span className="fw-semibold d-block mb-1">Total cartera</span>
                        <h3 className="card-title mb-1">$12,628</h3>
                        <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small>
                    </div>
                    <div className='list-inline-item'>
                        <span className="fw-semibold d-block mb-1">Pagos del mes</span>
                        <h3 className="card-title mb-1">$12,628</h3>
                        <small className="text-success fw-semibold"><i className="bx bx-up-arrow-alt"></i> +72.80%</small>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PagosAdmin;